import styled from "styled-components";

const getHeaderColors = (theme, tone) => {
  const t = tone === "surface" ? "surface" : "app"; // default: app
  if (t === "surface") {
    return {
      title: theme?.colors?.textPrimary ?? "#111",
      subtitle: theme?.colors?.textMuted ?? "#666",
    };
  }
  return {
    title: theme?.colors?.textOnAppBackground ?? "#fff",
    subtitle: theme?.colors?.textMutedOnAppBackground ?? "rgba(255,255,255,0.72)",
  };
};

export const PageHeader = styled.header`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;

  @media (max-width: 640px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const PageHeaderText = styled.div`
  min-width: 0;
  color: ${({ theme, $tone }) => getHeaderColors(theme, $tone).title};
`;

export const PageTitle = styled.h1`
  font-size: 20px;
  line-height: 1.2;
  margin: 0;
  color: inherit; /* ✅ herda do PageHeaderText */

  @media (min-width: 768px) {
    font-size: 24px;
  }
`;

export const PageSubtitle = styled.p`
  margin: 6px 0 0;
  font-size: 14px;
  color: ${({ theme, $tone }) => getHeaderColors(theme, $tone).subtitle};
`;

export const PageHeaderActions = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;

  @media (max-width: 640px) {
    justify-content: flex-end;
  }
`;
